/*
 * @Author: Ximen
 * @Date: 2021-03-18 15:57:31
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-15 18:54:47
 */
import environment from './environment';
import getMenuId from './getMenuId';
import topSign from './topSign';
import '@/untils/statement/type';

/**
 * 获取默认请求参数  isLogin 表示是否未登陆前的请求 默认登陆后
 */
const getParams = (param: object, isNoLogin = false, isPost = false) => {
  let params: TNumberString = {};
  const paramCopy = param as TString;
  Object.keys(paramCopy).forEach((key) => {
    if (paramCopy[key] === '') {
      delete paramCopy[key];
    }
  });
  if (isNoLogin) {
    params = {
      timestamp: new Date().getTime(),
      appkey: environment.appkey,
      menuId: environment.menuId,
      ...paramCopy,
    };
  } else if (isPost) {
    params = {
      timestamp: new Date().getTime(),
      memberId: localStorage.getItem('memberId') || '',
      accountId: localStorage.getItem('accountId') || '',
      token: localStorage.getItem('token') || '',
      siteId: localStorage.getItem('siteId') || '',
      appkey: environment.appkey,
      menuId: getMenuId(),
    };
  } else {
    params = {
      timestamp: new Date().getTime(),
      memberId: localStorage.getItem('memberId') || '',
      accountId: localStorage.getItem('accountId') || '',
      token: localStorage.getItem('token') || '',
      siteId: localStorage.getItem('siteId') || '',
      appkey: environment.appkey,
      menuId: getMenuId(),
      ...paramCopy,
    };
  }
  params.topSign = topSign(params).signString;
  // console.log('topSign=====>', params);
  return {
    ...params,
  };
};
export default getParams;
